import {BehaviorSubject, ReplaySubject} from 'rxjs';
import {filter} from 'rxjs/operators';
import {accountApi} from '@px/api/account';
import {marginApi} from '@px/api/margin';
import {fiat$} from './fiat';

export const userInfo$ = new BehaviorSubject<UserInfo>(createInitUserInfo());
export const userTags$ = new BehaviorSubject({});
export const userMemberLevel$ = new BehaviorSubject(0);
export const isSubAccount$ = new ReplaySubject<boolean>(1);
export const soulPassStatus$ = new BehaviorSubject(initStatus());
export const userSoulPassQualification$ = new BehaviorSubject(initQualification());

export const userGray$ = new BehaviorSubject(initGray());

export function resetUserInfo() {
  userInfo$.next(createInitUserInfo());
  fiat$.next('USD');
}

userInfo$.pipe(filter((o) => o.userId > 0)).subscribe(() => Promise.all([getSoulPassQualification(), getSoulPassStatus(), getUserGray()]));

async function getUserGray() {
  const {data} = await marginApi.getGray();
  if (data) {
    userGray$.next(data);
  }
}

async function getSoulPassQualification() {
  const {data} = await accountApi.getSoulPassQualification();
  if (data) {
    userSoulPassQualification$.next(data);
  }
}

async function getSoulPassStatus() {
  const {data} = await accountApi.getSoulPassStatus();
  if (data) {
    soulPassStatus$.next(data);
  }
}

function createInitUserInfo(): UserInfo {
  return {
    avatar: '7ec0d398bea20b43.png',
    clientCnt: '',
    email: '',
    lang: 'en',
    memberLevelCode: '',
    nickName: '',
    parentEmail: '',
    parentId: -1,
    previousUserId: 0,
    referralCode: '',
    referralType: -1,
    currency: 'USD',
    roles: [],
    totp: -1,
    userId: 0,
    lastLoginTime: 0,
    isMain: true,
    isSub: false,
    subUsers: [],
    uta: {
      spot: 0,
    },
    createTime: 0,
    marginTradingAccountInfo: {
      marginAccountStatus: 0,
      marginBorrowSceneCheck: false,
      marginTradeSceneCheck: false,
      marginTransferInSceneCheck: false,
      marginTransferOutSceneCheck: false,
    },
    lendingAccount: {
      status: 0,
    },
  };
}

function initQualification() {
  return {
    userId: 0,
    qualified: true, // 用户符合可min的条件
    whitelisted: false,
    tradingVolumeMet: false,
  };
}

/**
 * status value
 *  0 -> unbindAddress,
 *  1 -> bindAddress,
 *  2 -> minting,
 *  3 -> minted,
 *  4 -> revoking,
 * */
function initStatus() {
  return {
    clientId: 0,
    address: '',
    addressSource: '',
    chainName: '',
    status: -1,
    soulPassId: 0,
    chainTxHash: '',
    chainStatus: '',
    mintedCount: 0,
    revokedCount: 0,
  };
}

function initGray() {
  return {
    riskEngineMode: false, // 浮盈加仓灰度
    strategyUserGray: false,
    spotStrategyGrid: false,
  };
}
